import { render, staticRenderFns } from "./selCepillos.vue?vue&type=template&id=9bb4df6e&scoped=true&"
import script from "./selCepillos.vue?vue&type=script&lang=js&"
export * from "./selCepillos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb4df6e",
  null
  
)

export default component.exports